export default {
  name: 'UserHolidayReport',

  data () {
    return {
      currentReq: null,
      isLoading: false,
      exportCols: [],
      tableItems: [],
      filterValues: {
        company_id: null,
        fullname: null,
        division: null,
        department: null,
        jobPosition: null
      },
      paging: { limit: 20, page: 1, total: 0, pages: 0 }
    }
  },

  computed: {
    companyOptions () {
      let visibleCompanies;
      if (this.$session.get('user')) {
        visibleCompanies = this.$session.get('user')?.visible_companies.map(Number);
      } else {
        visibleCompanies = this.$session.get('visible_companies').map(Number);
      }
      let options = this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions(
          'user_companies',
          this.$i18n.locale,
          'disabled',
          '0'
        )
      );

      options = options.filter(
        el => (
          visibleCompanies.includes(parseInt(el.value))
        )
      );

      return options;
    },
    tableHeaders () {
      const headers = [
        { key: 'fullname', label: this.$t('holidays-report.fullname'), filterKey: 'fullname' },
        { key: 'job_name', label: this.$t('holidays-report.job-position'), filterKey: 'jobPosition' },
        { key: 'department_id', label: this.$t('holidays-report.department'), format: 'formatFromConfig', configKey: 'company_departments', configParam: 'name', filterKey: 'department' },
        { key: 'division_id', label: this.$t('holidays-report.division'), format: 'formatFromConfig', configKey: 'company_divisions', configParam: 'name', filterKey: 'division' },
        { key: 'company_id', label: this.$t('holidays-report.company'), format: 'formatFromConfig', configKey: 'user_companies', configParam: 'name' },
        { key: 'remainHoliday', label: this.$t('holidays-report.remain-holiday'), sortable: true, format: 'formatFunc', funcs: [this.showRemainHoliday], classFuncs: [this.isOverLimit] },
        { key: 'future_holidays_count', label: this.$t('holidays-report.future-holiday-count'), format: 'formatFunc', funcs: [this.showRemainHoliday] }
      ];
      return headers;
    },
    tableFilterConfig () {
      const filters = {
        company_id: {
          type: 'select',
          label: this.$t('user.company'),
          options: this.companyOptions,
          valueField: 'value',
          controlClass: 'form-control-sm',
          class: 'col-md-3'
        },
        fullname: {
          type: 'text',
          colOnlyFilter: false,
          label: this.$t('user.table.name-surname'),
          controlClass: 'form-control-sm',
          class: 'col-md-3'
        },
        jobPosition: {
          type: 'text',
          colOnlyFilter: true,
          label: this.$t('holidays-report.job-position'),
          controlClass: 'form-control-sm',
          class: 'col-md-3'
        },
        department: {
          type: 'text',
          colOnlyFilter: true,
          label: this.$t('holidays-report.department'),
          controlClass: 'form-control-sm',
          class: 'col-md-3'
        },
        division: {
          type: 'text',
          colOnlyFilter: true,
          label: this.$t('holidays-report.division'),
          controlClass: 'form-control-sm',
          class: 'col-md-3'
        }

      }
      return filters;
    },

    tableActions () {
      return { download: true };
    }
  },

  methods: {
    showRemainHoliday (val) {
      return val;
    },
    isOverLimit (val, data) {
      if (parseFloat(val) > 15) {
        return 'text-danger';
      }
    },
    getRequestPath (downloading = 0) {
      let path = 'user/holidays-report?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      path = this.ApiRequest.addGetParamsToPath(path, this.filterValues, true);
      if (downloading) {
        path += '&download=1';
      }
      return path;
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }

      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(this.getRequestPath(0), this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          this.tableItems = response.data.table;
          this.paging = response.paging;
        }
        this.isLoading = false;
      });
    },
    changePage (pageNr) {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }

      this.paging.page = pageNr;
      this.getTableData();
    },
    clearFilters () {
      this.filterValues = {};
      this.getTableData();
    },

    updateFilters () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    downloadList (html, exportCols) {
      this.isLoading = true;
      this.$refs.tableview.setDownloading(1);
      const reqData = {};
      this.ApiRequest.request(this.getRequestPath(1), this.ApiRequest.REQUEST_DOWNLOAD, reqData, () => {
        this.$refs.tableview.setDownloading(0);
      });
      this.isLoading = false;
    }
  },

  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    if (this.filterValues.orderByMulti && this.filterValues.orderByMulti[0] && !this.filterValues.orderByMulti[0].direction) {
      this.filterValues.orderByMulti[0].direction = 'DESC';
    }
    if (!this.filterValues.orderByMulti) {
      this.filterValues.orderByMulti = [{
        key: 'remainHoliday',
        direction: 'DESC'
      }]
    }
    this.getTableData();
  }
}
